export enum PaymentPreferenceEnum {
    "", "Ik verkies domicilliëring", "Ik verkies losse overschrijvingen"
}